<template>
    <div>
        <hts-modal
            :size="50"
            :show="openOfflineFee"
            :title="$t('labels.offlineFee')"
            @close="openOfflineFee = false">
            <hts-data-table
                ref="dataTables"
                class="mt-5"
                :headers="cHeaderPriceOfflineFee"
                :items="priceOfflineFee"
                :is-cell-clicked="false"
                :pagination="false"
                :is-footer="false"
                :first-data-rerender="firstDataRerender"
                @selection-changed="handleChangeSelection" />
        </hts-modal>
    </div>
</template>

<script lang="ts" setup>
import { $lodash } from '#imports'

const props = defineProps({
  priceOfflineFee: Array,
  selectionPriceOfflineFee: Array,
  edited: {
    type: Boolean,
    default: false
  },
  type: {
    type: String
  }
})
const { priceOfflineFee, selectionPriceOfflineFee, edited, type } = toRefs(props)
const { $formatters } = useNuxtApp()

const openOfflineFee = ref(false)

const openViewPriceOfflineFee = () => {
  openOfflineFee.value = true
}

defineExpose({
  openViewPriceOfflineFee
})

const CPriceOfflineFeeSelectedName = computed(() => {
  // return $lodash.map(selectionPriceOfflineFee?.value, '_id') || []
  return (
    selectionPriceOfflineFee?.value?.map((item: any) => {
      return routeName(item.positions)
    }) || []
  )
})
const emits = defineEmits(['update:selectionPriceOfflineFee'])

const getRouteName = (positions: Array<{ [key: string]: any }>) => {
  if (positions && Array.isArray(positions)) {
    const pluckData = $lodash.map(positions, 'fullNameNode')

    return $lodash.join(pluckData, ' >> ')
  }
}

const headerPriceOfflineFee = [
  // headers price offline fee
  {
    key: 'selection',
    suppressMenu: true,
    checkboxSelection: true,
    width: 50,
    maxWidth: 50
  },
  {
    field: 'route',
    headerName: $t('labels.route'),
    sortable: true,
    valueGetter: (params: any) => {
      return getRouteName(params?.data?.positions)
    }
  },
  {
    field: 'price',
    headerName: $t('labels.supplyList.price'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.formatCurrency(params?.data?.pricingEstimate.total)
    }
  },
  {
    field: 'offlineFee',
    headerName: $t('labels.offlineFee'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.formatCurrency(params?.data?.pricingEstimate.totalOfflineFee)
    }
  }
]

// Nếu được chỉnh sửa thì có selection
const cHeaderPriceOfflineFee = computed(() => {
  if (edited.value) {
    return headerPriceOfflineFee
  } else {
    const header = $lodash.cloneDeep(headerPriceOfflineFee)
    header.splice(0, 1)
    return header
  }
})

const routeName = (positions: { [key: string]: any }[]) => {
  if (positions && positions.length) {
    const name = positions.map((position: { [key: string]: any }) => position.fullNameNode)
    return `${name.join(' >> ')}`
  }
  return ''
}

// khi selection data table callable
const handleChangeSelection = (val: Array<{ [key: string]: any }>) => {
  emits('update:selectionPriceOfflineFee', val)
}

const firstDataRerender = (params: any) => {
  // Chỉnh sửa selecd những cái đã chọn
  if (type?.value && type.value === 'edit') {
    params.api.forEachNode((node: any) => {
      const name = routeName(node.data.positions)

      if (name && CPriceOfflineFeeSelectedName.value.includes(name)) {
        node.setSelected(true)
      }
    })

    return
  }

  // Thêm mới mặc định select all
  params.api.forEachNode((node: any) => {
    node.setSelected(true)
  })
}
</script>
